export default function MCCompareRunsView({ left, right }) {
  if (!left || !right) {
    return <p className="text-sm text-gray-500">Selecciona dos versiones para comparar.</p>
  }

  const leftData = JSON.parse(left.resultsJson || '{}')
  const rightData = JSON.parse(right.resultsJson || '{}')
  const keys = Array.from(new Set([...Object.keys(leftData), ...Object.keys(rightData)]))

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-3 py-2 text-left">Métrica</th>
            <th className="px-3 py-2 text-right">Versión A</th>
            <th className="px-3 py-2 text-right">Versión B</th>
            <th className="px-3 py-2 text-right">Delta</th>
          </tr>
        </thead>
        <tbody>
          {keys.map((k) => {
            const a = Number(leftData[k] || 0)
            const b = Number(rightData[k] || 0)
            return (
              <tr key={k} className="border-t">
                <td className="px-3 py-2">{k}</td>
                <td className="px-3 py-2 text-right">{a.toFixed(2)}</td>
                <td className="px-3 py-2 text-right">{b.toFixed(2)}</td>
                <td className="px-3 py-2 text-right">{(b - a).toFixed(2)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
